// extracted by mini-css-extract-plugin
export default {"searchContainer":"Search_searchContainer__U7MMV","search__icon":"Search_search__icon__MuMsw"};